import type { Order } from "@/types/supabase";

interface OrderTotalProps {
  order: Order;
}

export function OrderTotal({ order }: OrderTotalProps) {
  const total =
    (order.subtotal ?? 0) +
    (order.total_delivery_charge ?? 0) +
    (order.tax ?? 0) -
    (order.discount ?? 0);

  return (
    <span className="text-sm text-gray-600">
      ${total.toFixed(2)} {order.currency || "USD"}
    </span>
  );
}
